<header class="cover">
  <div class="cover--imageBackground">
    <img
      [src]="company.sign_in_image.large"
      loading="eager"
      decoding="async"
      [srcset]="company.sign_in_image | srcset"
    />
  </div>
  <div class="container">
    <div class="row">
      <div class="col-md-5 mb-3 mt-5">
        <div class="row">
          <div class="col-12 p-4 position-relative">
            <div class="transparent-bg d-none d-md-block"></div>
            <div class="row">
              <div class="col-12 col-md-10">
                <h3 class="cover--title text-primary">
                  {{ company.login_text_title }}
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="cover--description text-secondary">
                  {{ company.login_text_description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 offset-lg-3">
        <div class="session-content text-center card">
          <div class="mb-2">
            <h5 class="text-capitalize font-weight-bold mb-4">{{ "Login" }}</h5>
          </div>
          <div>
            <form [formGroup]="form" class="mb-2" (ngSubmit)="logIn()">
              <!-- Campo Email -->
              <div class="form-group text-left icon-form">
                <input
                  formControlName="email"
                  type="email"
                  class="form-control custom-input"
                  placeholder="Email"
                />
                <img src="assets/images/mootiva/mail.svg" loading="lazy" />

                <small
                  class="text-danger"
                  *ngIf="
                    form.controls.email.hasError('required') &&
                    form.controls.email.touched
                  "
                >
                  {{ "You must enter an email" | translate }}
                </small>
                <small
                  class="text-danger"
                  *ngIf="
                    form.controls.email.hasError('email') &&
                    form.controls.email.touched
                  "
                >
                  {{ "You must enter an valid email" | translate }}
                </small>
              </div>

              <!-- Campo Password -->
              <div class="form-group text-left icon-form">
                <input
                  formControlName="password"
                  [type]="showPassword ? 'text' : 'password'"
                  class="form-control custom-input password-input"
                  placeholder="Password"
                />
                <img src="assets/images/mootiva/pass.svg" loading="lazy" />
                <button
                  type="button"
                  class="password-toggle"
                  (click)="showPassword = !showPassword"
                  [attr.aria-label]="(showPassword ? 'Hide password' : 'Show password') | translate"
                >
                  <i class="fa" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>

                <small
                  class="text-danger"
                  *ngIf="
                    form.controls.password.hasError('required') &&
                    form.controls.password.touched
                  "
                >
                  {{ "You must enter a password" | translate }}
                </small>
              </div>

              <!-- Errores generales -->
              <small class="text-danger" *ngIf="showLoginError">
                {{ "Invalid credentials" | translate }}
              </small>
              <br />
              <small class="text-danger" *ngIf="showLoginError">
                {{ "invalid:message" | translate }}
              </small>

              <div class="text-center">
                <p class="text-info tooltip-container">
                  {{ "text:tooltip" | translate }}
                  <span class="custom-tooltip"
                    >   {{ "text:tooltip:body" | translate }}</span
                  >
                </p>
              </div>

              <!-- Botón de envío -->
              <div class="form-group mt-3">
                <button
                  type="submit"
                  class="btn btn-info"
                  [disabled]="form.controls.email.invalid || loading"
                >
                  {{ "Enter" | translate }}
                  <i
                    class="fa fa-circle-notch fa-spin ml-1"
                    *ngIf="loading"
                  ></i>
                </button>
              </div>
            </form>

            <div class="row" *ngIf="company.allow_registration">
              <div class="col-12">
                <p class="mb-0">
                  <span class="text-muted">{{
                    "You do not have an account yet?" | translate
                  }}</span>

                  <a
                    *ngIf="view_plans_logout"
                    [state]="{ ignoreLoadingBar: true }"
                    target="_self"
                    class="font-weight-bold ml-2"
                    [routerLink]="['/home']"
                    fragment="pricing"
                  >
                    {{ "Sign Up" | translate }}
                  </a>
                  <a
                    *ngIf="!view_plans_logout"
                    class="font-weight-bold ml-2"
                    [routerLink]="['/register']"
                  >
                    {{ "Sign Up" | translate }}
                  </a>
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <a class="font-weight-bold" [routerLink]="['/forgot']">{{
                  "I forgot my password" | translate
                }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
